<template>
    <div id="burger" :class="{ 'active' : isBurgerActive }" @click.prevent="toggle">
        <slot>
            <!-- <button type="button" class="burger-button" title="Menu">
                <span class="hidden">Winkelwagen</span>
                <span class="burger-bar burger-bar--1"></span>
                <span class="burger-bar burger-bar--2"></span>
                <span class="burger-bar burger-bar--3"></span>
            </button> -->
            <a href="#" id="shopping-cart">
                <i class="fas fa-shopping-cart"></i>
                <div class="d-none d-sm-inline">Mijn winkelmandje</div>
            </a>
        </slot>
    </div>
</template>
<script>
    import { store, mutations } from "@/store.js";

    export default {

        computed: {
            isBurgerActive() {
                return store.isNavOpen;
            }
        },
        methods: {
            closeSidebarPanel: mutations.toggleNav,

            toggle() {
                mutations.toggleNav();
            }
        }
    };
</script>
<style scoped lang="scss">
    .hidden {
        visibility: hidden;
    }
    #burger {
       /* margin-top: 45px;
        margin-left: 25px;*/
        display: inline-block;
    }

    #shopping-cart {
        text-transform: uppercase;
        padding: 10px 15px;
        border: 1px solid white;
        color: white;
        text-decoration: none;
        transition: all .25s ease;
        display: inline-block;
        text-align: center;
        margin-right: 20px;
        @media (min-width: 768px){
            padding: 20px 30px;
        }
        @media (min-width: 992px){
            &:hover, &:focus, &:active {
                color: black;
                background: white;
                i {
                    color: black;
                    transform: rotate(360deg);
                }
            }
        }
    }

    .fas, .fa-shopping-cart {
        color: white;
        font-size: 1.1rem;
        transition: all .25s ease;
        @media (min-width: 576px){
            margin-right: 12px;
        }
    }
</style>
